import { z } from 'zod';

export const LoqateRetrieveRequestSchema = z.object({
  data: z.object({
    Key: z.string(),
    Id: z.string(),
  }),
});

export const FullAddressSchema = z.object({
  Line1: z.string(),
  SubBuilding: z.string(),
  BuildingNumber: z.string(),
  Street: z.string(),
  PostalCode: z.string(),
  City: z.string(),
  Province: z.string(),
  CountryName: z.string(),
  CountryIso2: z.string(),
});

export const LoqateRetrieveResponseSchema = z.object({
  Items: z.array(FullAddressSchema),
});
